<template>
  <el-form ref="formOption"  label-width="90px">
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form-item label="题目：">
            <div v-if="IsTitle">
              <Editor placeholder="请输入内容" />
            </div>
            <div v-else>
             <span v-html="data.Content" class="yk-multiselect-question"></span>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="filesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="题目附件：">
            <div v-if="IsTitle">
              <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
            </div>
            <div v-else>
              <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" :offset="1" v-if="IsSelects == 0">
        <el-form-item label="选项：">
          <el-radio-group v-model="formOption.choice">
            <el-radio label="对"></el-radio>
            <el-radio label="错"></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="10" :offset="1" v-else-if="IsSelects> 0">
        <el-form-item label="选项：">
          <el-radio-group v-model="stuAnswer[0]" @change="doCheckValue">
            <el-radio label=1>对</el-radio>
            <el-radio label=0>错</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" :offset="1"  v-if="IsAnswers">
        <el-form-item label="答案：">
          <span v-if="data.Answers == 1">对</span>
          <span v-else>错</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row  v-show="IsAnalysis != 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析：">
            <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" />
            <span v-else v-html="data.Analysis">{{data.Analysis}}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnalysis != 0 && analysisFilesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析附件：">
            <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList" :IsUpload="false"/>
        </el-form-item>
      </el-col>
    </el-row> 
  </el-form>
</template>

<script>
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/QuestionBankFile.vue';

export default {
  name: 'true-false',
  components: {
    QuestionFile
  },
  props: {
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsAnswers: {
      type: Boolean,
      default: 0
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  watch: {},
  data() {
    return {
      urlAliyunOSS: '/api/design/osssign/getsign',
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      content: '请输入内容',
      formOption: {
        choice: null
      },
      stuAnswer: []
    };
  },
  methods: {
    // 做作业是选择答案
    doCheckValue: function() {
      this.$emit('getAnswer', {
        Id: this.data.Id,
        Answers: this.stuAnswer
      });
    }
  },
  created() {
    if (this.data.Answers) {
      this.stuAnswer = this.data.Answers;
    }
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.yk-multiselect-question{
    p{
      margin:0;
      padding:0;
    }
  }
</style>
